@if (!isSidebarLoading()) {
  <div class="h-full flex flex-col">
    <div class="bg-color-white">
      <app-commitment-sidebar-title
        [showBackButton]="!isEdit || (currentPage$ | async) !== COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE"
        [title]="isEdit ? 'Edit Change Order' : 'Add Change Order'"
        (goBack)="goBack()"
      ></app-commitment-sidebar-title>
    </div>

    @if ((currentPage$ | async) === 1) {
      <app-commitment-entry-text entryType="GeneralInfo" text="General Information"></app-commitment-entry-text>
    }
    <ng-scrollbar
      [ngClass]="{ 'first-page': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
      class="std-scrollbar wider-track"
      appearance="compact"
      orientation="vertical"
    >
      <div
        [ngClass]="{ 'mb-5 mt-4 horizontal-spacing': (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE }"
        class="scrollable-content"
      >
        @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
          <form class="flex flex-col flex-1" #firstPageForm="ngForm" role="form" [@fadeInGeneral]>
            <div class="flex-1 flex flex-col">
              <app-upload-commitments-sidebar
                [commitmentType]="COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER"
              ></app-upload-commitments-sidebar>
              <app-dropdown
                id="change_order_type"
                name="change_order_type"
                label="Change Order Type"
                placeholder="Change Order Type"
                [(ngModel)]="model.change_order_type"
                class="w-full"
                [required]="true"
                (ngModelChange)="updateChangeOrder('change_order_type')"
                [options]="changeOrderTypeOptions"
                optionLabel="label"
                optionValue="value"
                [disabled]="isEdit"
              ></app-dropdown>
              <app-floating-input
                id="title"
                label="Change Order Title"
                placeholder="Change Order Title"
                name="title"
                (change)="updateChangeOrder()"
                [(ngModel)]="model.title"
                class="w-full"
                required
              ></app-floating-input>
              <div class="two-input-row">
                <app-floating-input
                  [(ngModel)]="model.service_provider.name"
                  [required]="true"
                  [readonly]="true"
                  (click)="isDropdownShown.service_provider = true"
                  #optionsTrigger="cdkOverlayOrigin"
                  #serviceProviderModel="ngModel"
                  cdkOverlayOrigin
                  class="flex-1 cursor-pointer"
                  wrapperClass="cursor-pointer"
                  inputClass="cursor-pointer"
                  id="serviceProviderUserId"
                  name="serviceProviderUserId"
                  label="Company Name"
                  placeholder="Company Name"
                  [iconClass]="isDropdownShown.service_provider ? 'dropdown-icon opened' : 'dropdown-icon closed'"
                >
                </app-floating-input>
                <app-overlay-general
                  [(show)]="isDropdownShown.service_provider"
                  [trigger]="optionsTrigger"
                  [overlayPositions]="dropdownOverlayPositions"
                >
                  <app-company-dropdown
                    (optionSelected)="selectedCompany($event, serviceProviderModel)"
                    [hideAddCompany]="true"
                  ></app-company-dropdown>
                </app-overlay-general>
                <app-dropdown
                  optionLabel="title"
                  optionValue="id"
                  [disabled]="
                    (hasCommitments$ | async) ||
                    (!user.isPaidAccount && model?.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED)
                  "
                  [required]="true"
                  placeholder="Contract"
                  label="Contract"
                  id="contract_id"
                  name="contract_id"
                  [(ngModel)]="model.contract_id"
                  (ngModelChange)="updateChangeOrder(); loadContractSummaryDetails()"
                  [options]="filteredContractsByCompany"
                  class="w-full"
                >
                </app-dropdown>
              </div>
              <div class="flex justify-between items-center gap-2.5">
                <app-input-calendar
                  class="w-full"
                  [required]="true"
                  [date]="model.added_at"
                  [minStartDate]="(selectedContract$ | async)?.contract?.added_at ?? projectData?.start_date"
                  (dateChanged)="updateChangeOrderDate($event)"
                  [showIcon]="true"
                  placeholder="Change Order Date"
                ></app-input-calendar>
                <app-dropdown
                  [optionLabel]="null"
                  [optionValue]="null"
                  [disabled]="
                    (hasCommitments$ | async) ||
                    (!user.isPaidAccount && model?.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED)
                  "
                  [required]="true"
                  placeholder="Change Order Status"
                  label="Change Order Status"
                  id="approval_status"
                  name="approval_status"
                  [(ngModel)]="model.approval_status"
                  (ngModelChange)="updateChangeOrder()"
                  [options]="getApprovalStatuses()"
                  class="w-full"
                >
                  <ng-template #selectedContent #optionContent let-option>
                    <div class="capitalize text-navy-900 text-medium">{{ option }}</div>
                  </ng-template>
                </app-dropdown>
              </div>
              <app-floating-textarea
                [autoResize]="false"
                class="w-full"
                id="description"
                name="description"
                [(ngModel)]="model.description"
                (change)="updateChangeOrder()"
                label="Change Order Description (optional)"
                placeholder="Change Order Description (optional)"
              ></app-floating-textarea>
            </div>
          </form>
        } @else {
          <div [@fadeInGeneral]>
            @for (entry of spendEntriesData; track $index; let index = $index) {
              <div>
                <app-spend-entry
                  #spendEntries
                  [commitmentAddedAt]="model.added_at"
                  [model]="entry"
                  [projectData]="projectData"
                  [index]="index"
                  [commitmentType]="COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER"
                  [disableAddDescription]="model.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED && !!model?.id"
                  [disableRemoveEntry]="model.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED && !!model?.id"
                  [disableBudgetTagDropdown]="
                    model.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED && !!model?.id
                  "
                  [disabledAddDescriptionTooltip]="
                    model.approval_status === COMMITMENT_APPROVAL_STATUS.APPROVED && !!model?.id
                      ? 'Cannot add description to an approved change order'
                      : 'Select a line item first'
                  "
                  [changeOrderType]="model.change_order_type"
                ></app-spend-entry>
              </div>
            }
            <div class="horizontal-spacing mt-5 mb-2">
              <app-simple-button
                size="large"
                [wrapperClass]="{
                  'border-2 bg-transparent w-full rounded-[3px] ': true,
                  'border-blue-700 text-blue-700': (canAddChangeOrderSpendEntries$ | async),
                  'border-navy-500 text-navy-500': !(canAddChangeOrderSpendEntries$ | async),
                }"
                (click)="addSpendEntry()"
                [disabled]="!(canAddChangeOrderSpendEntries$ | async)"
                >Add Spend Entry
              </app-simple-button>
            </div>
          </div>
        }
        <!--        SECOND PAGE-->
      </div>
    </ng-scrollbar>
    <div
      class="bottom-container"
      [ngClass]="{ bordered: (currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.LAST_PAGE }"
    >
      @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.LAST_PAGE) {
        <span class="text-navy-700 text-base font-bold flex flex-1">
          <span class="flex-1">Total Change Order</span>
          <span class="flex-1 justify-center flex" [ngClass]="{ negative: (totalChangeOrderCost$ | async) < 0 }">
            @if ((totalChangeOrderCost$ | async) !== 0) {
              <span>{{ totalChangeOrderCost$ | async | money: 'positiveComa' }}</span>
            }
            @if ((totalChangeOrderCost$ | async) === 0) {
              <span>$ {{ totalChangeOrderCost$ | async | number }}</span>
            }
          </span>
        </span>
      }
      @if ((currentPage$ | async) === COMMITMENT_SIDEBAR_PAGE.FIRST_PAGE) {
        <app-simple-button
          [wrapperClass]="{
            rounded: true,
          }"
          (click)="incrementPage()"
          [disabled]="isLoading"
        >
          @if (!isLoading) {
            <span>Next</span>
          }
          @if (isLoading) {
            <span class="icon-refresh animate-spin"></span>
          }
        </app-simple-button>
      } @else {
        <app-simple-button
          (click)="save()"
          [disabled]="isLoading"
          [wrapperClass]="{
            'bg-yellow-500 rounded': true,
          }"
        >
          @if (!isLoading) {
            <span>Submit</span>
          }
          @if (isLoading) {
            <span class="icon-refresh animate-spin"></span>
          }
        </app-simple-button>
      }
    </div>
  </div>
} @else {
  <div class="flex w-full h-full items-center justify-center">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
